export const SUPPORT_EMAIL =
  process.env.REACT_APP_PUBLIC_SUPPORT_EMAIL || "support@myfarmingpal.com";

export const CONTACT_SUPPORT_PATH = "/contact";

export const getSupportMailto = (subject = "MyFarmingPal support request") =>
  `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;
